module.exports = __webpack_public_path__ + "img/product-placeholder-45.8870d1a.png";